// components/ProtectedRoute/ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classes from './ProtectedRoute.module.css';

const ProtectedRoute = ({ children }) => {
    const { isLoggedIn, isInitialized, loading } = useSelector((state) => state.auth);
    const location = useLocation();

    // Show loading spinner while checking authentication
    if (!isInitialized || loading) {
        return (
            <div className={classes.loadingContainer}>
                <div className={classes.loadingSpinner}>
                    <div className={classes.spinner}></div>
                    <p className={classes.loadingText}>Authenticating...</p>
                </div>
            </div>
        );
    }

    // If not logged in, redirect to home with the attempted location
    if (!isLoggedIn) {
        return <Navigate to="/" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;